// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"a3a24fc8","277":"f1892c9a","729":"66b2379b","895":"ee7ff4eb"}[chunkId] + ".chunk.js";
};